module.exports = __webpack_public_path__ + "img/graph-model.73d981e3.svg";